import { combineReducers, configureStore } from '@reduxjs/toolkit';
import mainFilterSlice, { updateMainFilterFromUrl } from '../features/mainFilter/mainFilterSlice';
import secondaryFilterSlice, { updateSecondaryFilterFromUrl } from '../features/secondaryFilter/secondaryFilterSlice';
import priceGraphSlice from '../features/priceGraph/priceGraphSlice';
import dealsListSlice from '../features/dealsList/dealsListSlice';
import locationDealsSlice from '../features/locationDeals/locationDealsSlice';
import favoriteSlice from '../features/favorite/favoriteSlice';
import onboardingSlice, { setVisibleSteps } from '../features/wizard-v2/onboardingSlice';
import appSlice, { setAppState } from '../appSlice';
import userSearch from '../features/search/searchSlice';
import searchSlice from '../features/mainFilter/searchSlice';
import countersSlice from './slices/countersSlice';
import mainFilterModalsReducer from '../features/mainFilter/mainFilterModalsSlice';
import secondaryFilterModalsReducer from '../features/secondaryFilter/secondaryFilterModalsSlice';
import prefetchDealsSlice from '../features/dealsList/prefetchDealsSlice';
import userSlice from '../features/user/userSlice';
import { favoritesApi } from '../features/favorite/rtkFavoriteSlice';
import { sliderTutorialMessagesApi } from '../features/dealsList/rtkSliderTutorialMessages';
import customizeButtonSlice from '../features/customize-button/customizeButtonSlice';
import mainApi from '../api/rtkMainApi';

const store = configureStore({
  reducer: {
    app: appSlice,
    search: searchSlice,
    mainFilter: mainFilterSlice,
    secondaryFilter: secondaryFilterSlice,
    dealsList: dealsListSlice,
    prefetchDeals: prefetchDealsSlice,
    priceGraph: priceGraphSlice,
    locationDeals: locationDealsSlice,
    favorite: favoriteSlice,
    onboarding: onboardingSlice,
    userSearch: userSearch,
    counters: countersSlice,
    modals: combineReducers({
      mainFilter: mainFilterModalsReducer,
      secondaryFilter: secondaryFilterModalsReducer,
    }),
    user: userSlice,
    customize: customizeButtonSlice,
    [favoritesApi.reducerPath]: favoritesApi.reducer,
    [sliderTutorialMessagesApi.reducerPath]: sliderTutorialMessagesApi.reducer,
    [mainApi.reducerPath]: mainApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      favoritesApi.middleware,
      sliderTutorialMessagesApi.middleware,
      mainApi.middleware,
    ),
});

window.travelyo_hf_engine_status = () =>
  store.getState().mainFilter.searchEngine;

window.showWizard = () => {
  store.dispatch(setVisibleSteps());
  store.dispatch(setAppState({ showOnboardingV2: true }));
}

window.triggerManualFiltersUpdate = () => {
  store.dispatch(updateMainFilterFromUrl());
  store.dispatch(updateSecondaryFilterFromUrl());
}

// Get the type of our store variable
export type AppStore = typeof store
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch']

export default store;
